<template>
    <div class="MyCourse">
        <TopBar/>
        <div class="content" v-show="pageState">
            <div class="adv-img">
                <img src="../../assets/img/course.png" alt="课程">
            </div>
            <div class="list-wrap">
                <ul class="list-course">
                    <li class="item item-hover"
                        :class="{item_hover:animationList.classId === item.crs_id}"
                        v-for="(item,index) in courseList"
                        :key="item.crs_id"
                        @click="goVideo(index)"
                        @mouseenter="enter(item.crs_id)"
                        @mouseleave="leave()"
                    >
                        <h1>{{item.crs_name}}</h1>
                        <div>
                            <span>主讲老师:&nbsp;</span>
                            <span>{{item.instru_name}}</span>
                        </div>
                        <div class="progress-wrap">
                            <span>学习进度</span>
                            <div class="progress">
                                <el-progress :percentage="item.study_rate" :color="colorFun(item.crs_id)"
                                             :show-text="false"></el-progress>
                            </div>
                            <span>{{item.study_rate}}%</span>
                        </div>
                        <!--渐变背景圆-->
                        <div class="circular-warp" v-show="animationList.classId === item.crs_id">
                            <div class="circular1"></div>
                            <div class="circular2"></div>
                            <div class="circular3"></div>
                            <div class="circular4"></div>
                            <div class="circular5"></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <my-bottom/>
    </div>
</template>

<script>
    import TopBar from "../../components/common/TopBar"
    import myBottom from "../../components/common/MyBottom"

    export default {
        name: "MyCourse",
        data() {
            return {
                courseList: [],
                animationList: {
                    colorHover: "#3D89FB",
                    classId: -1
                },
                progressColor: '',
                //login 函数
                loading: '',
                //页面显示状态
                pageState: false
            }
        },
        components: {
            TopBar,
            myBottom
        },

        created() {
            if (this.$route.query.url){
              localStorage.setItem('loginUrl',this.$route.query.url);
            }
            this.getCourse();
            this.is_login();
        },
        methods: {
            //判断是否登录
            is_login() {
                //判断是否已经登录，如果未登录则跳转到登录页，如果已经登录则跳转到首页
                let my_token = localStorage.getItem('my_token')

                //这里的话,字符串是否为空的判断不算最严谨的，后期如果有时间再优化一下。
                if (my_token == null || my_token == '') {
                    //跳转到登录页面
                    this.loading.close();
                    this.$router.push('/login')

                } else {
                    this.loading.close();
                    //判断token是否已经过期，如果过期则跳转到登录页面
                    let valid_time = localStorage.getItem('valid_end_time')
                    var end_time = new Date(valid_time);
                    var now = new Date()
                    if (now.getTime() >= end_time.getTime()) {
                        /**2020-09-01 JZ新增 token失效时去除loding  开始*/
                        this.loading.close();
                        /**2020-09-01 JZ新增 token失效时去除loding  结束*/
                        //跳转到登录页面
                        if( poUrl != '0' && poUrl != null){
                          this.$router.push('/' + poUrl)
                        }else{
                          this.$router.push('/login')
                        }
                        this.$message.warning('token过期，请重新登录！');
                    }
                }
            },
            getCourse() {
                this.loading = this.$loading({
                    lock: true,
                });
                this.$get(this.BASEURL + '/prestudy/course').then((res) => {
                    if (res.code === 200) {
                        this.courseList = res.data;
                        if (this.courseList.length === 0) {
                            if (this.courseList.length === 0) {
                                this.loading.close();
                                this.$router.push({
                                    path: '/CourseMessage',
                                });
                            }
                        }
                        let self = this;
                        self.pageState = true;
                        setTimeout(function () {
                            self.loading.close();
                        }, 200)
                    } else {
                        this.$message({
                            message: res.error,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            enter(id) {
                this.animationList.classId = id;
            },
            leave() {
                this.animationList.classId = '';
            },
            colorFun(id) {
                return this.progressColor = id === this.animationList.classId ? "#FC6257" : "#3D89FB";
            },
            goVideo(index) {
                if (this.courseList[index].image_url !== '') {
                    //路由传参
                    this.$router.push({
                        path: '/PlayVideo',
                        query: {
                            id: this.courseList[index].crs_id,
                            crs_name: this.courseList[index].crs_name,
                            instru_name: this.courseList[index].instru_name,
                            rate: this.courseList[index].study_rate
                        }
                    });
                } else {
                    this.$message({
                        message: "当前章节未绑定视频！请联系客服老师",
                        type: 'error',
                        duration: 2000
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .MyCourse {
        position: relative;
        width: 100%;
        height: 100vh;
        min-height: 100vh;
        background-color: #f5f5f5;
        .content {
            padding-top: 85px;
            min-height: calc(100% - 60px);
            padding-bottom: 50px;
            box-sizing: border-box;
            .adv-img {
                font-size: 0;
                img {
                    width: 100%;
                }
            }
            .list-wrap {
                max-width: 1200px;
                margin: 0 auto;
                .list-course {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .item {
                        position: relative;
                        overflow: hidden;
                        text-align: center;
                        width: 384px;
                        height: 168px;
                        margin-bottom: 24px;
                        background-color: #FFFFFF;
                        border-radius: 4px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        h1 {
                            font-family: PingFang SC;
                            font-size: 22px;
                            line-height: 30px;
                            color: #666666;
                            font-weight: normal;
                            margin-bottom: 12px;
                        }
                        span {
                            font-family: PingFang SC;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                            color: #666666;
                        }
                        .progress-wrap {
                            display: flex;
                            align-items: center;
                            margin-top: 16px;
                            .progress {
                                width: 74px;
                                margin: 0 6px 0 10px;
                            }
                        }
                        .circular-warp {
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            .circular1 {
                                position: absolute;
                                right: -83px;
                                width: 166px;
                                height: 166px;
                                border-radius: 100%;
                                background: linear-gradient(to right, rgba(255, 255, 255, .6), rgba(255, 255, 255, .1));
                                opacity: .1;
                            }
                            .circular2 {
                                position: absolute;
                                right: -10px;
                                bottom: -61px;
                                width: 135px;
                                height: 135px;
                                border-radius: 100%;
                                background: linear-gradient(to right, rgba(255, 255, 255, .6), rgba(255, 255, 255, .1));
                                opacity: .1;
                            }
                            .circular3 {
                                position: absolute;
                                left: -85px;
                                bottom: -90px;
                                width: 170px;
                                height: 170px;
                                border-radius: 100%;
                                background: linear-gradient(to right, rgba(255, 255, 255, .6), rgba(255, 255, 255, .1));
                                opacity: .3;
                            }
                            .circular4 {
                                position: absolute;
                                top: -34px;
                                left: 0;
                                width: 54px;
                                height: 54px;
                                border-radius: 100%;
                                background: linear-gradient(to right, rgba(255, 255, 255, .6), rgba(255, 255, 255, .1));
                                opacity: .4;
                            }
                            .circular5 {
                                position: absolute;
                                top: 0;
                                left: -36px;
                                width: 58px;
                                height: 58px;
                                border-radius: 100%;
                                background: linear-gradient(to right, rgba(255, 255, 255, .6), rgba(255, 255, 255, .1));
                                opacity: .4;
                            }
                        }
                    }
                    .item_hover {
                        background: linear-gradient(92deg, rgba(122, 189, 253, 1) 0%, rgba(102, 159, 251, 1) 100%);
                        h1 {
                            color: #F5F5F5;
                        }
                        span {
                            color: #F5F5F5;
                        }
                    }
                }
            }
        }
    }
</style>
